import { useQuery, useMutation } from "react-query";
import {
	get_reward_accounts_api,
	get_reward_ledger_api,
	get_reward_credits_api,
	reverse_reward_ledger_entry_api,
	get_reward_tiers_api,
} from "../services/rewards";

export const useGetRewardAccounts = (payload) =>
	useQuery(["getRewardAccounts", payload], () => get_reward_accounts_api(payload));

export const useGetRewardLedger = (payload) =>
	useQuery(["getRewardLedger", payload], () => get_reward_ledger_api(payload));

export const useGetRewardCredits = (payload) =>
	useQuery(["getRewardCredits", payload], () => get_reward_credits_api(payload));

export const useGetRewardTiers = () =>
	useQuery("getRewardTiers", () => get_reward_tiers_api(), { staleTime: 5 * 60 * 1000 });

export const useReverseRewardLedgerEntry = () =>
	useMutation("reverseRewardLedgerEntry", (body) => reverse_reward_ledger_entry_api(body));
